import React from "react";
import loader from "../../components/loader/loader";
import { APIURL } from "../../redux/action/config";
import NoImage from "../../assets/images/noimages.jpg";

const ViewStaff = ({viewDetails,modalId}) => {
  const viewData = viewDetails?.user ? viewDetails?.user : "";
  const getBadge = (status) => {
    switch (status) {
      case "available":
        return "success";
      case "busy":
        return "warning";
      default:
        return "primary";
    }
  };

  return (
    <React.Fragment>
      <div
        className="modal fade"
        id={modalId}
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header border-0">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
                {viewDetails && viewData?._id ? (
                  <form
                  id="kt_modal_new_target_form"
                  className="form fv-plugins-bootstrap5 fv-plugins-framework"
                  action="#"
                >
                  <div className="mb-8 text-center">
                    <h1 className="mb-3 text-primary">Staff Detail</h1>
                    {/* <div className="text-muted fw-bold fs-5">
                      If you need more info, please check out.
                    </div> */}
                  </div>
                  <div className="separator d-flex flex-center mb-8"></div>
                  <div className="row mb-5">
                    <div className="col-md-12 fv-row fv-plugins-icon-container">
                      <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                        <span>Profile Picture</span>
                      </label>
                      <div>
                        <img
                          className="mw-150px"
                          src={viewData?.image ? APIURL + "/" + viewData?.image : NoImage}
                          alt="profile"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row mb-5">
                    {/* <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                        <span>Staff Code </span>
                      </label>
                      <div className="text-gray-400 fs-4 fw-bold">
                        {viewData?.user_code}
                      </div>
                    </div> */}
                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                        <span>FirstName</span>
                      </label>
                      <div className="text-gray-400 fs-4 fw-bold">
                        {viewData?.firstName ? viewData?.firstName : "N/A"}
                      </div>
                    </div>
                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                        <span>Middle Name</span>
                      </label>
                      <div className="text-gray-400 fs-4 fw-bold">
                        {viewData?.middleName ? viewData?.middleName : "N/A"}
                      </div>
                    </div>
                  </div>
                  <div className="row mb-5">
                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                        <span>Last Name</span>
                      </label>
                      <div className="text-gray-400 fs-4 fw-bold">
                        {viewData?.lastName ? viewData?.lastName : "N/A"}
                      </div>
                    </div>
                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                        <span>Experience</span>
                      </label>
                      <div className="text-gray-400 fs-4 fw-bold">
                        {viewData?.experience ? viewData?.experience : "N/A"}
                      </div>
                    </div>
                  </div>

                  <div className="row mb-5">
                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                        <span>Phone Number</span>
                      </label>
                      <div className="text-gray-400 fs-4 fw-bold">
                        {viewData?.phone ? viewData?.phone : "N/A"}
                      </div>
                    </div>
                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                        <span>Email Address</span>
                      </label>
                      <div className="text-gray-400 fs-4 fw-bold">
                        {viewData?.email ? viewData?.email : "N/A"}
                      </div>
                    </div>
                  </div>
                  <div className="row mb-5">
                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                        <span>Designation</span>
                      </label>
                      <div className="text-gray-400 fs-4 fw-bold">
                        {viewData?.designation ? viewData?.designation : "N/A"}
                      </div>
                    </div>
                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                        <span>Status</span>
                      </label>
                      <div className="text-gray-400 fs-4 fw-bold text-capitalize">
                        <span
                          className={`btn ${getBadge(
                            viewData?.status
                          )} text-capitalize`}
                        >
                          {viewData?.status ? viewData?.status : "N/A"}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div></div>
                </form>
                ) : loader()}
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ViewStaff;
